import { FileListItem } from '@views/documents/elements/FileList'

export const ITEMS_PER_PAGE = 5

export const getTotalPages = (totalItems: number, pageSize: number): number => Math.ceil(totalItems / pageSize)

export const getPaginatedItems = (items: FileListItem[], currentPage: number, pageSize: number): FileListItem[] =>
  items.slice((currentPage - 1) * pageSize, currentPage * pageSize)
